export default __webpack_public_path__ + "locales/sl/FormGallery.json?hash=185725d8b08ac0cbd0958629fb0998a5";